export default "__VITE_ASSET__e8afb407__"